import { TransferKeys } from "@/modules/transaction/common/enum";

export const accountTransferTemplateCommissionFieldKeys = [
  TransferKeys.Amount,
  TransferKeys.Currency,
  TransferKeys.DebitAccount,
  TransferKeys.CreditAccount,
];
